const valueToOptionLabel = (options, value) => {
  if (!value) {
    return undefined;
  }
  const foundOption = options.find(option => {
    return option.value.toString() === value.toString();
  });
  if (foundOption) {
    return foundOption.label;
  } else {
    return undefined;
  }
};
const labelToOptionValue = (options, label, caseSensitive = true) => {
  const finder = caseSensitive
    ? option => {
        return option.label === label;
      }
    : option => {
        return option.label.toLowerCase() === label.toLowerCase();
      };
  const foundOption = options.find(finder);
  if (foundOption) {
    return foundOption.value;
  } else {
    return undefined;
  }
};
const extractFieldFromArray = (fields, label, options, attribute) => {
  const value = labelToOptionValue(options, label);
  if (value) {
    return fields.find(field => {
      return field[attribute].toString() === value.toString();
    });
  } else {
    return undefined;
  }
};

const EnumHelper = {
  extractFieldFromArray,
  labelToOptionValue,
  valueToOptionLabel,
};

export default EnumHelper;
